import { Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

type Props = {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const AIListingNextConfirmModal = ({ open, onClose, onContinue }: Props) => (
  <Modal
    open={open}
    onOpenChange={(isOpen) => !isOpen && onClose()}
    size={{ base: 'fullScreen', md: 'md' }}
    dividers={false}
    header={
      <Heading level={2} textStyle="heading-sm">
        Do you need to add any other photos or notes?
      </Heading>
    }
    body={
      <Paragraph>
        After you leave this page, the AI will start generating your property description and amenities. You can add
        more photos and edit the description once that process is finished, but you won&apos;t be able to return to this
        page to give the AI more material to work from. If you think you have more to add, do so now before continuing.
      </Paragraph>
    }
    footer={
      <ButtonGroup aria-label="Confirm navigation">
        <TextButton tone="brand" onClick={onClose}>
          Add more details
        </TextButton>
        <Button tone="brand" emphasis="filled" onClick={onContinue}>
          Continue
        </Button>
      </ButtonGroup>
    }
  />
);

export default AIListingNextConfirmModal;
